
<v-card class="v-flex p-0" flat style="border-radius: unset" @click="onClick"  >
    <div class="measure-name primary white--text">
        {{ name }}
    </div>
    <div class="measure-value secondary lighten-4 secondary--text">
        {{ measure }}
    </div>
</v-card>
